/* eslint-disable react/jsx-no-useless-fragment */
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useResetUserPassword } from "../../services/auth-api";
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  Form,
  FormField,
  FormItem,
  FormMessage,
  Input,
} from "@repo/ui";
import Swal from "sweetalert2";

export default function PasswordResetModal({ show, onClose, user }) {
  const {
    mutate: resetPassword,
    isPending: resettingPassword,
    isSuccess: passwordReset,
    data: resetData,
  } = useResetUserPassword();

  const form = useForm({
    defaultValues: { email: user?.email },
  });

  const { handleSubmit, control } = form;

  const onSubmit = (payload) => {
    resetPassword(payload?.email);
  };

  useEffect(() => {
    if (passwordReset) {
      onClose(false);
      Swal.fire({
        icon: "success",
        title: `<h4 style="margin: 0; font-size: 20px">Reset Password successfully!</h4>`,
        html: `
              <div style="text-align: left;">
                
                <div style="font-size: 16px; display: flex; align-items: center; gap: 8px; margin-bottom: 15px;">
                  <span style="white-space: nowrap;">Temporary Password:</span>
                  <input 
                    readonly
                    id="tempPassInput" 
                    style="padding: 6px; border: 1px solid #ddd; border-radius: 4px; flex: 1;"
                  value="${resetData?.data?.tempPassword || ""}"
                    />
                <button id="copyBtn" style="padding: 8px 10px; background: #f31700; color: white; border: none; border-radius: 4px; cursor: pointer; white-space: nowrap; font-size: 14px;">
                  Copy
                </button>
              </div>
              <div style="background: #fff8e1; padding: 4px; border-left: 4px solid #ffc107; margin: 10px 0 0; font-size:12px">
              <p style="margin: 0;"><strong>⚠️ Important:</strong></p>
              <ul style="margin: 5px 0 0 15px; padding-left: 5px; list-style: disc; text-align: left;">
                <li>You must <strong>save this password now</strong> - it won't be shown again</li>
                <li><strong>Share it securely</strong> with the user immediately</li>
                <li>If lost, the user will need to <strong>request a password reset</strong></li>
                <li>Expires on: <strong>${resetData?.data?.expiryDate?.split("T")[0] || ""}</strong></li>
              </ul>
            </div>
            `,
        didOpen: () => {
          const copyButton = document.getElementById("copyBtn");
          copyButton.addEventListener("click", () => {
            const tempPassInput = document.getElementById("tempPassInput");
            tempPassInput.select();
            document.execCommand("copy");
            // Visual feedback
            copyButton.textContent = "Copied!";
            copyButton.style.background = "#28a745";
            setTimeout(() => {
              copyButton.textContent = "Copy";
              copyButton.style.background = "#f31700";
            }, 1500);
          });
        },
        confirmButtonText: "Close",
        allowOutsideClick: false,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [passwordReset]);

  return (
    <>
      <Dialog open={show} onOpenChange={onClose}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Confirm Password Reset</DialogTitle>
          </DialogHeader>
          <DialogDescription className="p-4">
            <p>Are you sure you want to reset the password?</p>
            <Form {...form}>
              <form
                className="w-full flex gap-2 my-3"
                onSubmit={handleSubmit(onSubmit)}
              >
                <FormField
                  control={control}
                  name="email"
                  rules={{
                    required: "Email is Required.",
                  }}
                  render={({ field }) => (
                    <FormItem className="flex-1">
                      <Input type="text" readOnly {...field} />
                      <FormMessage />
                    </FormItem>
                  )}
                />
                <Button
                  variant="secondary"
                  isLoading={resettingPassword}
                  disabled={resettingPassword}
                >
                  Confirm
                </Button>
              </form>
            </Form>
            <p>This action will:</p>
            <ul className="mt-1 list-disc list-inside">
              <li>{`Immediately invalidate the user's current password.`}</li>
              <li>Generate a temporary password.</li>
              <li>Require the user to change their password on next login.</li>
            </ul>
          </DialogDescription>
        </DialogContent>
      </Dialog>
    </>
  );
}
